import {gql} from "@apollo/client";

export const GET_MY_SINGLE_ORDER = gql`
  query ($id: Int!, $paranoid: Boolean) {
    getMyOrderDetail(id: $id, paranoid: $paranoid) {
      errors {
        message
      }
      data {
        id
        roomId
        orderNumber
        accountHolder
        billTo
        note
        secondaryNote
        hasUnreadMessage
        agency {
          id
          name
          expiresAt
        }
        orderedService {
          id
          service {
            id
            name
            criticalDeadline {
              from
              to
              value
            }
            fields {
              id
              name
              type
              inputFieldName
              multipleInputFieldName
              isRequired
              isHidden
              ioType
              cluster
            }
            clusters {
              id
              name
              isHidden
              isRepeatable
            }
          }
          fields {
            fieldId
            documents
            data {
              name
              value
            }
            cluster
          }
        }
        billingAddress {
          id
          companyName
          fiscalCode
          vatNumber
          address
          streetNumber
          cityId
          postalCode
          provinceId
          email
          invoiceHolder
        }
      }
    }
  }
`;

export const GET_ALL_MY_ORDERS = gql`
  query ($offset: Int, $limit: Int) {
    getAllMyOrders(
      order: [["createdAt", "DESC"]]
      paranoid: false
      isPublished: null
      limit: $limit
      offset: $offset
    ) {
      count
      data {
        id
        orderNumber
        dylogId
        masterId
        roomId
        createdAt
        status
        note
        secondaryNote
        dylogId
        dylogSyncCompleted
        dylogCompanyId
        prautoPraticheId
        prautoPraticheCaseNumber
        prautoPraticheYear
        accountHolder
        secondAccHolder {
          name
          firstName
          lastName
        }
        accHolder {
          name
          firstName
          lastName
        }
        agency {
          name
          firstName
          lastName
        }
        orderedService {
          suspendedAt
          suspendedNote
          admin {
            firstName
            lastName
          }
          status
          service {
            id
            name
            rootType
          }
          entityOrderService {
            id
            entityid
            entityname
            pec {
              id
              email
              expirationDate
            }

            drivingLicense {
              id
              licenseNumber
              fiscalCode
              category
            }

            contract {
              registrationNumber
              flatTaxRate
              isCompleted
              contractType
              startDate
              endDate
            }
          }
        }
      }
      errors {
        message
      }
    }
  }
`;

export const GET_ALL_MY_PENDING_ORDERS = gql`
  query {
    getAllMyOrders(
      order: [["createdAt", "DESC"]]
      isPublished: false
      paranoid: false
      limit: 1
    ) {
      data {
        id
        orderNumber
        billTo
        billingAddress {
          id
        }
        agency {
          fiscalCode
          vatNumber
          businessName
          houseNumber
          postalCode
          municipalityId
          province
          email
          pecEmail
          address
        }
        accHolder {
          name
          fiscalCode
          vatNumber
          businessName
          houseNumber
          postalCode
          municipalityId
          province
          email
          pecEmail
          address
          companyTypeId
          regionId
          streetId
          documentTypeId
          documentNumber
          expiresAt
        }
        orderedService {
          id
          service {
            name
            id
            fields {
              id
              name
              type
              ioType
              multipleInputFieldName
            }
            criticalDeadline {
              from
              to
              value
            }
          }
          fields {
            fieldId
            documents
            data {
              name
              value
            }
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
